// @ts-nocheck
import config from './config/config';

import { FirebaseApp, initializeApp, FirebaseOptions } from 'firebase/app';
import { getDatabase, Database } from 'firebase/database';

const firebaseConfig: FirebaseOptions = {
  apiKey: config.firebase.key,
  databaseURL: config.firebase.databaseURL,
  projectId: config.firebase.projectId,
  appId: config.firebase.appId,
};

let app: FirebaseApp;
let database: Database;

if (typeof window !== 'undefined') {
  // Initialize Firebase
  app = app || initializeApp(firebaseConfig);

  database = database || getDatabase(app);
}

export { database };

export default app;
